import { useEffect, useRef } from 'react';

import { Button } from '../../../Components/ui';
import { formatDisplayPhoneNumber } from '../../../Helpers/phoneUtils';

const CallbackSummary = ({ data = {} }) => {
    const headingRef = useRef(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (headingRef.current) {
            headingRef.current?.focus?.();
        }
    }, []);

    // Edit time button click handler
    const handleEditTimeClick = () => {
        const url = new URL(window.location.href);
        url.searchParams.set('edit', '1');
        window.location.href = url.toString();
    };

    return (
        <div className="callback-summary-wrapper">
            {/* Main heading and subtext */}
            <div className="heading-section">
                <div className="heading-section__text">
                    <h1 ref={headingRef}>You're All Set! 🎉</h1>
                    <h3>
                        Thank you for scheduling a call with our team—we’re excited to help you find the right business
                        insurance!
                    </h3>
                    <p>
                        We'll call you around your scheduled time—give or take a minute or two. Looking forward to
                        speaking with you soon!
                    </p>
                </div>
            </div>
            {/* Appointment details card */}
            <form className="callback-summary-container">
                <h3>You are confirmed. Here are your appointment details.</h3>
                <div className="callback-summary">
                    {/* Left Column */}
                    <div className="callback-summary-column">
                        <dl>
                            <dt>Customer name:</dt>
                            <dd>{data.customerName}</dd>
                        </dl>
                        {data.comment && (
                            <dl>
                                <dt>Comments:</dt>
                                <dd>{data.comment}</dd>
                            </dl>
                        )}
                    </div>
                    {/* Right Column */}
                    <div className="callback-summary-column">
                        <dl>
                            <dt>Call back at:</dt>
                            <dd>{data.dateTime}</dd>
                        </dl>
                        <dl>
                            <dt>Phone:</dt>
                            <dd>{formatDisplayPhoneNumber(data.phoneNumber)}</dd>
                        </dl>
                    </div>
                </div>
                <div className="callback-summary-small">
                    <dl>
                        <dt>Customer name:</dt>
                        <dd>{data.customerName}</dd>
                    </dl>
                    <dl>
                        <dt>Call back at:</dt>
                        <dd>{data.dateTime}</dd>
                    </dl>
                    <dl>
                        <dt>Phone:</dt>
                        <dd>{formatDisplayPhoneNumber(data.phoneNumber)}</dd>
                    </dl>
                    <dl>
                        <dt>Comments:</dt>
                        <dd>{data.comment}</dd>
                    </dl>
                </div>
                <div className="callback-edit-row">
                    <Button type="button" btn-type="secondary" onClick={handleEditTimeClick}>
                        Edit Time
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default CallbackSummary;
